import React from 'react'
import './grid.css'

export default function Grid({ children }) {
    return (
        <div className='css__grid'>
            { children }
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/CSSGrid/index.js